function calSaving() {
   let a = document.querySelector('.mu-savings .notranslate')
            let discount = BSS_B2B.shopData.cart.bss_b2b_total_price
            let total = BSS_B2B.shopData.cart.original_total_price
            let saving = (total - discount) / 100
            if (a) {
                a.innerText = '-£' + saving
            }
}

function restyleRF() {
    let cartItem = document.querySelectorAll('.mu-cart-item')
    if (cartItem) {
        cartItem.forEach((e) => {
            let varriantId = e.getAttribute('data-variant-id')
            let muCart = mu_cart_items
            mu_cart_items.forEach((item) => {
                if (item.variant_id == varriantId) {
                    let price = e.querySelector('.mu-item-price')
                    price.setAttribute('bss-b2b-cart-item-key', item.key)
                    price.setAttribute('bss-b2b-final-line-price', '')
                }
            })
        })
        let totalPrice = document.querySelector('#mu-checkout-button span')
        if (totalPrice) {
            totalPrice.setAttribute('bss-b2b-cart-total-price', '')
        }
        let subPrice = document.querySelector('#mu-checkout-container .mu-subtotal .notranslate ')
        if (subPrice) {
            subPrice.setAttribute('bss-b2b-cart-total-price', '')
        }

        let buttoncheckout = document.querySelector('#mu-checkout-button')
        if (buttoncheckout) {
            buttoncheckout.classList.add('checkout-btn')
        }
        setTimeout(() => {
            BSS_B2B.observer.cartSubject.listenCartCheckout()
            calSaving()
        }, 200)
        BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
    }
}


function fixChangQuannityCart() {
    let a = document.querySelectorAll('.mu-item-price')
    a.forEach((e) => {
        e.classList.add("bss_price")
    })
    setTimeout(() => {
       const event = new Event('bss.b2b.amo.doneCheckAMOByBSS');
        document.dispatchEvent(event);
        setTimeout(() => {
            let a = document.querySelectorAll('.mu-item-price')
            a.forEach((e) => {
              e.classList.remove("bss_price")
            })
          calSaving()
        }, 1000)
       setTimeout(() => {
          calSaving()
        }, 2500)
    }, 500)
}


let loop = setInterval(() => {
    if (document.querySelectorAll('.mu-cart-item').length) {
        clearInterval(loop);
        restyleRF();
        let a = document.querySelector('#cart-icon')
        if (a) {
            a.addEventListener("click", () => {
                setTimeout(() => {
                    restyleRF()
                }, 500)
            });
            let b = document.querySelector('.product-info__add-button button')
            if (b) {
                b.addEventListener("click", () => {
                    setTimeout(() => {
                        restyleRF()
                    }, 500)
                });
            }
        }

        // gán sự kiện change quantity

        let quantity = document.querySelectorAll('.mu-item-quantity .mu-border')
        if (quantity && quantity.length) {
            quantity.forEach((e) => {
                e.addEventListener('click', () => {
                    fixChangQuannityCart()
                  
                })
            })
        }

      // gán sự kiện change discount
      setTimeout(()=>{
        let discount = document.querySelectorAll('.mu-item-bundle')
      if (discount && discount.length) {
            discount.forEach((e) => {
                e.addEventListener('click', () => {
                    fixChangQuannityCart()
                })
            })
        }
      },1000)
    }
}, 100)
setTimeout(() => {
    clearInterval(loop);
}, 15000)


     fixTe()


function fixTe() {
   let a = document.querySelector('.bss-b2b-tax-ex-wrapper')
  if (a) {
    let b =  document.querySelector('.cart-page-recommendations')
    if (b) {
      b.before(a)
    }
  }
}
// setTimeout(() =>{
//     function handleButtonClick(e) {
//       e.preventDefault();
//       const $button = $(this);
//       let oldText = $(this).text();
//       $button.css({'pointer-events': 'none', 'opacity': '0.6'});
//       $button.text("Loading ...");
//       setTimeout(() =>{
//         $button.css({'pointer-events': 'unset', 'opacity': '1'})
//           $button.text(oldText);
//       }, 2000);
//     }
   
//    $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
//   }, 500)


setTimeout(() => {
    function handleButtonClick() {
        let a = document.querySelectorAll('.cart-item .qty-input__btn , .cart-item__remove')
        if (a.length) {
            a.forEach((e) => {
                e.addEventListener('click', () => {
                    setTimeout(() => {
                        BSS_BCP.netterm.showButtonOnCartPage()
                        handleButtonClick()
                        BSS_B2B.observer.cartSubject.listenCartCheckout()
                    }, 2000)
                })
            })
        }
    }
    handleButtonClick()


    let quickAddDrawer = document.querySelector('.cart__summary')
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
             document.querySelector( 'button[name="checkout"]').style.pointerEvents = 'none';
              document.querySelector( 'button[name="checkout"]').style.opacity = '0.6';
                setTimeout(() => {
                        BSS_B2B.observer.cartSubject.listenCartCheckout()
                    }, 100)
               setTimeout(() => {
                           document.querySelector( 'button[name="checkout"]').style.pointerEvents = 'unset';
              document.querySelector( 'button[name="checkout"]').style.opacity = '1';
                    }, 1000)
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }

}, 1500)
